import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import PageTitle from "../common/PageTitle";
import BillLogo from "./shared/BillLogo";
import { Button, Grid, TextField, Typography, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useMutation } from "react-query";
import { selcoEnquiryApiCaller } from "shared/endPoints/apiCallers";
import Notiflix from "notiflix";
import { intlTranselate } from "shared/utils/ppUtils";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import translate from "i18n/translate";
import ShareModal from "components/profile/ShareModal";
import ApiRequest from "../../actions/ApiRequest";
import LoadingButton from "@mui/lab/LoadingButton";
import { useHistory } from "react-router-dom";
import { Selco as SelcoLogo } from "assests/images/bundles/paltel/paltelImage";
import { useSelector } from "react-redux";
import { intl } from "i18n/provider";

const propTypes = {};

const translations = {
  ar: {
    account_number: "رقم الحساب",
    desired_amount: "المبلغ",
    electric_company: "شركة الكهرباء",
    meter_number: "رقم المشترك",
    name: "اسم المشترك ",
    tarif_description: "نوع الحساب",
    less_than_50: "على الاقل 50 شيقل",
    value: "القيمه",
    search: "بحث",
    "searching...": "جاري البحث ...",
    Error: "خطأ",
    "Returned MSG": "رسالة الخطأ",
    "Amount Due": "المبلغ المستحق",
    "Remaining Amount": "المبلغ المتبقي",
    voucher_number: "رقم الفاتورة",
    no_of_kw: "عدد الكيلوات",
    Confirm: "تأكيد",
    "Voucher Generated": "تم إنشاء الفاتورة",
    SmallPrint: "طباعة (POS)",
  },
  en: {
    account_number: "Account Number",
    desired_amount: "Desired Amount",
    electric_company: "Electric Company",
    meter_number: "Meter Number",
    name: "Name",
    tarif_description: "Tarif Description",
    less_than_50: "At least 50 NIS",
    value: "Value",
    search: "Search",
    "searching...": "Searching ...",
    Error: "Error",
    "Returned MSG": "Returned MSG",
    "Amount Due": "Amount Due",
    "Remaining Amount": "Remaining Amount",
    voucher_number: "Voucher Number",
    no_of_kw: "No of KW",
    Confirm: "Confirm",
    "Voucher Generated": "Voucher Generated",
    SmallPrint: "Small Print (POS)",
  },
  he: {
    account_number: "מספר חשבון",
    desired_amount: "כמות מבוקשת",
    electric_company: "חברת חשמל",
    meter_number: "מספר מונה",
    name: "שם",
    tarif_description: "תיאור תעריף",
    less_than_50: "לפחות 50 שקל",
    value: "ערך",
    search: "חיפוש",
    "searching...": "מחפש ...",
    "Remaining Amount": "הסכום הנותר",
    "Amount Due": "סכום לתשלום",
    "Returned MSG": "הודעה שחזרה",
    Error: "שגיאה",
    voucher_number: "Voucher Number",
    no_of_kw: "מספר קו",
    Confirm: "אשר",
    "Voucher Generated": "קופון נוצר",
    SmallPrint: "הדפסה קטנה (POS)",
  },
};

export default function Selco(props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [formData, setFormData] = useState({ amount: 0, sNumber: "" });
  const [confirmMessage, setConfirmMessage] = useState("");
  const [userInformation, setUserInformation] = useState({});
  const [amountIsValid, setAmountIsValid] = useState(true);
  const [printedData, setPrintedData] = useState({});
  const [reviewData, setReviewData] = useState({});
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [showOthersButtons, setShowOthersButtons] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [selcoBuyData, setSelcoBuyData] = useState(null);
  const [isError, setIsError] = useState(false);
  const locale = localStorage.langCity;
  const history = useHistory();
  const sellerId = useSelector((state) => state.auth.user?.id);

  useEffect(() => {
    const { state } = history.location;

    if (state?.number) {
      setFormData({ amount: 0, sNumber: state.number });
    }
  }, []);

  // Listen for Top20 number click events
  useEffect(() => {
    const handleFillPhoneNumber = (event) => {
      const phoneNumber = event.detail?.phoneNumber;
      if (phoneNumber) {
        console.log('Selco: Received phone number from Top20:', phoneNumber);
        setFormData((prev) => ({ ...prev, sNumber: phoneNumber }));
      }
    };

    window.addEventListener('fillBillPhoneNumber', handleFillPhoneNumber);

    return () => {
      window.removeEventListener('fillBillPhoneNumber', handleFillPhoneNumber);
    };
  }, []);

  const selcoEnquiry = (data) => {
    setShowConfirm(true);
    // Use the passed data or fall back to formData
    const amount = data?.amount || formData.amount;
    const sNumber = data?.sNumber || formData.sNumber;

    const formattedMessage = intl.formatMessage(
      { id: "selcoConfirmationMessage" },
      {
        amount: `<span style="font-weight: bold; font-size: 1.2em; ">${amount}</span>`,
        number: `<span style="font-weight: bold; font-size: 1.2em; ">${sNumber}</span>`,
      }
    );

    setConfirmMessage(formattedMessage);
  };

  const callBuyVoucherApi = async (form) => {
    setIsLoading1(true);
    try {
      const res = await ApiRequest.post(
        `/selco_buy_voucher?s_number=${form.sNumber}&amount=${form.amount}`
      );
      if (res?.status === "failed") {
        Notiflix.Notify.failure(res?.reason || "Something went wrong");
        return;
      }
      setConfirmMessage("");

      // Handle new simplified response format: data = {"Token": voucher_number}
      const voucherNumber = res.data?.Token || res.data?.voucher_number || "N/A";
      const cleanVoucherNumber = enforceLTR(voucherNumber.toString()).replace(/\*/g, "");

      // Create simplified data structure
      const updatedData = {
        [translations[locale]["voucher_number"]]: cleanVoucherNumber,
        [translations[locale]["meter_number"]]: form.sNumber,
        [translations[locale]["desired_amount"]]: `${form.amount} NIS`
      };

      setSelcoBuyData(updatedData);

      // Create data for printing and sharing
      const combinedObject = {
        [translations[locale]["voucher_number"]]: cleanVoucherNumber,
        [translations[locale]["meter_number"]]: form.sNumber,
        [translations[locale]["desired_amount"]]: `${form.amount} NIS`,
        [translations[locale]["electric_company"]]: "Selco"
      };

      const stringifiedData =
        "\n" +
        Object.entries(combinedObject)
          .map(([key, value]) => `${key}: ${value}`)
          .join("\n") +
        "\n";
      setReviewData(stringifiedData);
      setPrintedData(combinedObject);
      setShowOthersButtons(true);
    } catch (e) {
      Notiflix.Notify.failure(`Something went wrong !`, "", "Close");
    } finally {
      setIsLoading1(false);
    }
  };

  function printData(obj) {
    // Create modern printable receipt with Selco logo
    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Selco Voucher Receipt</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
            
            * { margin: 0; padding: 0; box-sizing: border-box; }
            
            body { 
              font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
              background: white;
              padding: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
            }
            
            .receipt-container {
              background: white;
              border-radius: 20px;
              box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
              padding: 0;
              max-width: 400px;
              width: 100%;
              overflow: hidden;
              border: 2px solid #e0e0e0;
            }
            
            .receipt-header {
              background: linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%);
              color: white;
              padding: 30px 25px;
              text-align: center;
              position: relative;
            }
            
            .selco-logo {
              width: 80px;
              height: 80px;
              background: white;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 15px;
              padding: 10px;
              box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            }
            
            .selco-logo img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 50%;
            }
            
            .receipt-title {
              font-size: 24px;
              font-weight: 700;
              margin-bottom: 8px;
              text-shadow: 0 2px 4px rgba(0,0,0,0.1);
            }
            
            .receipt-subtitle {
              font-size: 14px;
              opacity: 0.9;
              font-weight: 400;
            }
            
            .receipt-body {
              padding: 30px 25px;
            }
            
            .status-badge {
              display: inline-block;
              background: #4CAF50;
              color: white;
              padding: 8px 16px;
              border-radius: 20px;
              font-size: 12px;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.5px;
              margin-bottom: 25px;
            }
            
            .info-grid {
              display: grid;
              gap: 20px;
              margin-bottom: 25px;
            }
            
            .info-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 15px 0;
              border-bottom: 1px solid #f0f0f0;
            }
            
            .info-item:last-child {
              border-bottom: none;
            }
            
            .info-label {
              font-size: 14px;
              color: #666;
              font-weight: 500;
            }
            
            .info-value {
              font-size: 14px;
              color: #333;
              font-weight: 600;
              text-align: right;
            }
            
            .voucher-highlight {
              background: linear-gradient(135deg, #2E7D32 0%, #4CAF50 100%);
              color: white;
              border-radius: 15px;
              padding: 20px;
              text-align: center;
              margin: 25px 0;
            }
            
            .voucher-label {
              font-size: 12px;
              opacity: 0.8;
              margin-bottom: 5px;
              text-transform: uppercase;
              letter-spacing: 1px;
            }
            
            .voucher-value {
              font-size: 18px;
              font-weight: 700;
              font-family: 'Courier New', monospace;
              letter-spacing: 1px;
              word-break: break-all;
              line-height: 1.2;
            }
            
            .receipt-footer {
              background: #f8f9fa;
              padding: 20px 25px;
              text-align: center;
              border-top: 1px solid #e0e0e0;
            }
            
            .footer-text {
              font-size: 12px;
              color: #666;
              line-height: 1.5;
            }
            
            .decorative-line {
              height: 4px;
              background: linear-gradient(90deg, #2E7D32, #4CAF50, #2E7D32);
              margin: 20px 0;
              border-radius: 2px;
            }
            
            @media print {
              body { background: white; padding: 0; }
              .receipt-container { box-shadow: none; border: 1px solid #ddd; }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <div class="receipt-header">
              <div class="selco-logo">
                <img src="${SelcoLogo}" alt="Selco Logo" />
              </div>
              <div class="receipt-title">Voucher Receipt</div>
              <div class="receipt-subtitle">Selco Electricity</div>
            </div>
            
            <div class="receipt-body">
              <div class="status-badge">✓ Success</div>
              
              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">Meter Number</span>
                  <span class="info-value">${obj[translations[locale]["meter_number"]] || 'N/A'}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Amount Paid</span>
                  <span class="info-value">${obj[translations[locale]["desired_amount"]] || 'N/A'}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Company</span>
                  <span class="info-value">${obj[translations[locale]["electric_company"]] || 'Selco'}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">${translations[locale]["Date"] || "Date"}</span>
                  <span class="info-value">${new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}</span>
                </div>
              </div>
              
              <div class="decorative-line"></div>
              
              <div class="voucher-highlight">
                <div class="voucher-label">Voucher Number</div>
                <div class="voucher-value">${obj[translations[locale]["voucher_number"]] || 'N/A'}</div>
              </div>
            </div>
            
            <div class="receipt-footer">
              <div class="footer-text">
                Thank you for using Selco services<br>
                This voucher serves as proof of payment<br>
                <strong>Printed on: ${new Date().toLocaleString()}</strong>
              </div>
            </div>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
  }

  function printPOSData(obj) {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();

    const voucherNumber = obj[translations[locale]["voucher_number"]] || "N/A";
    const customerName = obj[translations[locale]["name"]] || "N/A";
    const amount = obj[translations[locale]["desired_amount"]] || "N/A";
    const noOfKw = obj[translations[locale]["no_of_kw"]] || "N/A";

    const printableContent = `
      <!DOCTYPE html>
      <html dir="${locale === "ar" || locale === "he" ? "rtl" : "ltr"}">
        <head>
          <meta charset="UTF-8">
          <title>POS Receipt</title>
          <style>
            @page { margin: 0; }
            body { 
              font-family: 'Courier New', Courier, monospace;
              width: 58mm;
              margin: 0;
              padding: 2mm;
              font-size: 12px;
              color: #000;
              line-height: 1.2;
            }
            .header { text-align: center; font-weight: bold; margin-bottom: 5px; border-bottom: 1px dashed #000; padding-bottom: 3px; font-size: 14px; }
            .item { display: flex; justify-content: space-between; margin-bottom: 2px; }
            .label { font-weight: bold; }
            .voucher-box { border: 1px solid #000; padding: 5px; text-align: center; margin: 5px 0; font-size: 18px; font-weight: bold; word-break: break-all; }
            .footer { text-align: center; margin-top: 5px; font-size: 10px; border-top: 1px dashed #000; padding-top: 3px; }
            @media print {
              body { width: 58mm; }
            }
          </style>
        </head>
        <body>
          <div class="header">
            SELCO
          </div>
          <div class="info">
            <div class="item">
              <span class="label">${translations[locale]["name"]}:</span>
              <span>${customerName}</span>
            </div>
            <div class="item">
              <span class="label">${translations[locale]["desired_amount"]}:</span>
              <span>${amount}</span>
            </div>
            <div class="item">
              <span class="label">${translations[locale]["no_of_kw"]}:</span>
              <span>${noOfKw}</span>
            </div>
          </div>
          <div class="voucher-box">
            ${voucherNumber}
          </div>
          <div class="footer">
            PhonePlay - ${formattedDate}
          </div>
        </body>
      </html>
    `;

    const printWindow = window.open("", "_blank");
    printWindow.document.open();
    printWindow.document.write(printableContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  }

  const renderDialog = () => {
    return (
      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
        <DialogTitle id="alert-dialog-title" sx={{ textAlign: 'center' }}>
          {showOthersButtons ? (
            // After purchase - show Selco logo and title
            <>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '15px' }}>
                <img
                  src={SelcoLogo}
                  alt="Selco Logo"
                  style={{ width: '60px', height: '60px', borderRadius: '50%', border: '2px solid #2E7D32' }}
                />
              </div>
              <Typography variant="h5" sx={{ color: '#2E7D32', fontWeight: 'bold' }}>
                {translate("Voucher Generated")}
              </Typography>
            </>
          ) : (
            // Before purchase - show confirmation message
            translate("areYouSure")
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {!showOthersButtons && confirmMessage && (
              <Typography
                variant="h6"
                dangerouslySetInnerHTML={{ __html: confirmMessage }}
              />
            )}
            <Grid container justifyContent={"center"}>
              {Object.entries(printedData || {}).map(([key, val], i) => {
                return (
                  <Grid
                    item
                    xs={12}
                    md={12}
                    container
                    justifyContent={"center"}
                    key={i}
                  >
                    <Typography color="black" style={{ fontWeight: key === translations[locale]["voucher_number"] ? "bold" : "normal" }}>
                      {key + " : " + val}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', gap: 2 }}>
          {!showOthersButtons ? (
            // Before purchase - show Cancel and Confirm buttons
            <>
              <Button
                onClick={() => {
                  setShowConfirm(false);
                  setShowOthersButtons(false);
                }}
                variant="outlined"
                color="secondary"
                sx={{ minWidth: 100 }}
              >
                {translate("Cancel")}
              </Button>
              <LoadingButton
                variant="contained"
                onClick={() => {
                  if (!!selcoBuyData) {
                    setShowConfirm(false);
                  } else {
                    callBuyVoucherApi(formData);
                  }
                }}
                loading={isLoading1}
                disabled={isError}
                sx={{ minWidth: 120 }}
              >
                {translations[locale]["Confirm"]}
              </LoadingButton>
            </>
          ) : (
            // After purchase - show OK, Print, Share buttons
            <>
              <Button
                onClick={() => {
                  setShowConfirm(false);
                  setShowOthersButtons(false);
                  // Go back to main screen
                  history.push('/pay_bills');
                }}
                variant="contained"
                color="success"
                sx={{ minWidth: 100 }}
              >
                {translate("OK")}
              </Button>
              <Button
                onClick={() => {
                  printData(printedData);
                }}
                variant="outlined"
                color="secondary"
                sx={{ minWidth: 100 }}
              >
                {translate("Print")}
              </Button>
              <Button
                onClick={() => {
                  printPOSData(printedData);
                }}
                variant="contained"
                sx={{ minWidth: 100, backgroundColor: "#4caf50", "&:hover": { backgroundColor: "#388e3c" } }}
              >
                {translations[locale]["SmallPrint"]}
              </Button>
              <Button
                onClick={() => setShareModalVisible(true)}
                variant="outlined"
                color="primary"
                sx={{ minWidth: 100 }}
              >
                {translate("Share")}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  };
  function enforceLTR(str) {
    return `\u202A${str}\u202C`;
  }

  return (
    <React.Fragment>
      {renderDialog()}
      <ShareModal
        shareModal={shareModalVisible}
        setShareModal={setShareModalVisible}
        contentMessage={reviewData}
      />

      <PageTitle title={translate("Selco")} backPage="/pay_bills">
        <form
          id="Selco_form"
          onSubmit={(e) => {
            e.preventDefault();
            const amount = e.target.amount.value;
            const sNumber = e.target.sNumber.value;

            if (Number(amount) < 50) {
              setAmountIsValid(false);
              return;
            }
            setAmountIsValid(true);
            setFormData({ amount, sNumber });
            selcoEnquiry({ sNumber, amount });
          }}
        >
          <BillLogo src={SelcoLogo} alt="selco" style={{}} />
          <Grid pt={2} container width="100%" spacing={3}>
            <Grid item xs={12} container justifyContent={"center"}>
              <Grid item xs={6}>
                <TextField
                  required
                  name="sNumber"
                  fullWidth
                  label={translations[locale]["meter_number"]}
                  onChange={(e) =>
                    setFormData({ ...formData, sNumber: e.target.value })
                  }
                  value={formData.sNumber}
                  autoFocus
                  disabled={isLoading1}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} container justifyContent={"center"}>
              <Grid item xs={6}>
                <TextField
                  required
                  fullWidth
                  inputProps={{
                    min: 50,
                  }}
                  error={!amountIsValid}
                  helperText={
                    !amountIsValid && translations[locale]["less_than_50"]
                  }
                  name="amount"
                  placeholder={translations[locale]["desired_amount"]}
                  label={translations[locale]["value"]}
                  disabled={isLoading1}
                />
              </Grid>
            </Grid>
            <Grid item container justifyContent={"center"}>
              <LoadingButton variant="contained" type="submit">
                {translate("submit")}
              </LoadingButton>
            </Grid>
          </Grid>
        </form>

        <Box sx={{ display: 'flex', marginTop: 4, marginBottom: 2 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/pay_bills")}
            sx={{ minWidth: 120 }}
          >
            {translate("Back")}
          </Button>
        </Box>
      </PageTitle>
    </React.Fragment>
  );
}

Selco.propTypes = propTypes;
